import Observer from 'common/scripts/observer';
import {Utils} from 'common/scripts/utils';

const observer = new Observer();

class MenuTrigger {
    constructor() {
        /**
         * Элемент, по которому кликают
         * @type {null}
         */
        this.button = null;

        /**
         * Состояние кнопки
         * true - открыто
         * false - закрыто
         * @type {Boolean}
         */
        this.isOpen = false;

        this.openClass = 'is-open';
    }

    /**
     * Инициализирует компонент
     * @param {Object} options - объект настроек
     */
    init(options) {
        this.button = options.wrapper;
        this.isOpen = this.button.classList.contains(this.openClass);

        this._changeState = this._changeState.bind(this);
        this._bindEvents();
    }

    /**
     * Навешивает слушателей
     * @private
     */
    _bindEvents() {
        this.button.addEventListener('click', this._changeState);

        const events = ['resize', 'orientationchange'];

        events.forEach((event) => {
            window.addEventListener(event, this._onResize.bind(this));
        });
    }

    /**
     * Определяет, десктоп или нет
     * @returns {boolean} - true - десктоп
     * @private
     */
    _isDesktop() {
        return Utils.isBreakpoint(1280, 10000);
    }

    _onResize() {
        if (this.isOpen && this._isDesktop()) {
            this._changeState();
        }
    }

    /**
     * Изменяет состояние
     * с отрытого на закрытое и наоборот
     * @private
     */
    _changeState() {
        this.isOpen = !this.isOpen;
        const method = this.isOpen ? 'add' : 'remove';

        this.button.classList[method](this.openClass);
        this._publishState();
    }

    /**
     * Сообщает о состоянии элемента
     * @private
     */
    _publishState() {
        observer.publish(this.isOpen ? 'openMenuTrigger' : 'closeMenuTrigger');
    }
}

export default MenuTrigger;
